import React from 'react'

function Payroll() {
  return (
    <>
      
    <div className='border border-5 mx-5 mt-5'>
      <h4>Employee details</h4>
      <div className='d-flex'> 
          <div>
            <label htmlFor="">Email address</label>
            <input type="text" placeholder='Enter email address' className='w-100' />
          </div>
          <div className='mx-3'>
            <label htmlFor="">Department</label>
            <input type="text" placeholder='Employees department' className='w-100 '/>
          </div>
      </div>
    </div>

  </>
  )
}

export default Payroll